/*
 * @Author: Kida
 * @Date: 2020-11-20 09:27:48
 * @LastEditTime: 2021-03-24 17:33:22
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Input\InputBase.js
 */
import * as THREE from 'three'
import { Camera } from '../Camera'
import { CameraController } from '../CameraController'
import { CameraPoint, CPointSet } from '../CameraPoints'
import { config } from '../config'

export class InputBase {
  constructor () {
    this.enable = true

    this.dlon = 0
    this.dlat = 0
    this.dtranslate = new THREE.Vector2()
    this.dzoom = 0

    this.activate = false

    /**
     *  @type {Camera} 摄像机
     */
    this.cam = null
    /**
     *  @type {CameraController} 控制器
     */
    this.controller = null
  }

  get cameraController () {
    return this.controller
  }

  set cameraController (value) {
    if (value) {
      this.controller = value
      this.cam = value.camera
    } else {
      this.controller = null
      this.cam = null
    }
  }

  /**
   * 寻找离最近摄像机方向角度最小的点位
   *
   * @param {THREE.Vector3} cameraPos 摄像机位置
   * @param {THREE.Vector3} dir 方向
   * @param {CPointSet} cps 点位集合
   * @returns {{dot:number, cpoint:CameraPoint}} 与目标角度的cos值，目标点位
   */
  static findInNeighbour (camCurrIdx, cameraPos, dir, cps) {
    const dirCam = new THREE.Vector2(dir.x, dir.z).normalize()
    const minDot = Math.cos(config.Interact.MaxDeg)
    let minA = 0
    let minDist = Number.MAX_VALUE
    let minCp = null

    const neighbour = cps.findVisiable(camCurrIdx)

    for (const idx of neighbour) {
      const cp = cps.getCameraPoint(idx)

      const distSq = cameraPos.distanceToSquared(cp.position)
      const dirCp = new THREE.Vector2(cp.position.x - cameraPos.x, cp.position.z - cameraPos.z).normalize()
      const dot = dirCam.dot(dirCp)
      if (dot > minDot && distSq < minDist) {
        minA = dot
        minDist = distSq
        minCp = cp
      }
    }
    return { dot: minA, cpoint: minCp }
  }

  init (setting) {}

  depose () {}

  camUpdate () {

  }

  update () {

  }

  clearTransformation () {
    this.dlon = 0
    this.dlat = 0
    this.dtranslate.x = 0
    this.dtranslate.y = 0
    this.dzoom = 0

    this.activate = false
  }
}
